import React from 'react';
import {Image, Text} from '@chakra-ui/react';
import {NavLink, useLocation, useRouteMatch} from 'react-router-dom';
import {LinkComponent} from '../../interfaces/interfaces';

export default function MenuLinks({status, linkUrl, linkName, imgActive, img, altText}: LinkComponent) {
  let {url} = useRouteMatch();
  let {pathname} = useLocation();
  return (
    <NavLink exact={status} to={linkUrl}
             className={"menu--links"}
             activeStyle={{
               backgroundColor: "#FFFBEB",
               padding: "10px 20px",
               borderRadius: "20px",
               margin: "-10px 0px 30px -20px",
             }}
    >
      {pathname === linkUrl ? <>
        <Image
          boxSize="30px"
          objectFit="cover"
          mr="10px"
          src={imgActive}
          alt={`${altText} icon`}
        />
        <Text textTransform="capitalize" fontWeight="bold">
          {linkName}
        </Text>
      </> : <>
        <Image
          boxSize="30px"
          objectFit="cover"
          mr="10px"
          src={img}
          alt={`${altText} icon`}
        />
        <Text textTransform="capitalize">
          {linkName}
        </Text>
      </>}
    </NavLink>
  )
}
